module.exports = __webpack_public_path__ + "img/portrait-expressive-young-woman 2.da85eaa8.png";